import React, { useEffect, useState } from "react";
import TitleComp from "./TitleComp";
import { Button, Card, Pagination, Popconfirm, Table, Tag } from "antd";
import { get, post } from "../../apiService";
import { ImBlocked } from "react-icons/im";
import { FaUniversalAccess } from "react-icons/fa";
import { render } from "@testing-library/react";
import moment from "moment";
import TextArea from "antd/es/input/TextArea";

export default function BlockIpAddress() {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [searchInput, setSearchInput] = useState("");
  const [loading, setLoading] = useState(false);
  const [visitsData, setVisitsData] = useState([]);
  const [reasonMessage, setResonMessage] = useState();

  const columns = [
    { title: "IP Address", dataIndex: "ip_address", key: "ip_address" },
    {
      title: "City",
      dataIndex: "city",
      key: "city",
    },
    {
      title: "Region",
      dataIndex: "region",
      key: "region",
    },
    {
      title: "Postal",
      dataIndex: "postal",
      key: "postal",
    },
    {
      title: "Country",
      dataIndex: "country",
      key: "country",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) =>
        text == 1 ? (
          <Tag color="#87d068">Active</Tag>
        ) : (
          <Tag color="#f50">Blocked</Tag>
        ),
    },
    {
      title: "Reason",
      dataIndex: "reason",
      key: "reason",
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (text, record) => moment(text).format("llll"),
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => {
        return (
          <div className="d-flex">
            {record.status == "1" ? (
              <Popconfirm
                placement="topLeft"
                title="Are sure you want to block this IP ?"
                description={
                  <TextArea
                    value={reasonMessage}
                    onChange={(e) => setResonMessage(e.target.value)}
                    maxLength={250}
                    placeholder="Reason"
                  />
                }
                okText="Yes"
                onConfirm={() => handleOk(record.id, 0)}
                cancelText="No"
              >
                <Button
                  icon={<ImBlocked />}
                  className="bg-danger text-white mx-3"
                  style={{ height: "35px" }}
                >
                  Blocked This
                </Button>
              </Popconfirm>
            ) : (
              <Button
                icon={<FaUniversalAccess />}
                className="bg-success text-white mx-3"
                style={{ height: "35px" }}
                onClick={() => handleOk(record.id, 1)}
              >
                Unblocked This
              </Button>
            )}
          </div>
        );
      },
    },
  ];

  // ====================== Fetch Team Detail ==============
  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchVisits(pagination.current, pagination.pageSize, searchInput);
    }, 300);

    return () => {
      clearTimeout(dbounce);
    };
  }, [pagination.current, pagination.pageSize, searchInput]);

  const fetchVisits = async (current, pageSize, search) => {
    setLoading(true);

    try {
      const action = "fetch";
      const response = await get(
        `/block_ipaddress.php?action=${action}&limit=${pageSize}&page=${current}${
          search ? "&search=" + search + "" : ""
        }`
      );
      setVisitsData(response?.message?.list);
      setPagination((prev) => ({
        ...prev,
        current,
        pageSize,
        total: response?.message?.total,
      }));
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  // ===================== Update Status ===========================

  const handleOk = async (id, status) => {
    try {
      const formData = new FormData();
      formData.append("id", id);
      formData.append("reason", reasonMessage);
      formData.append("status", status);
      formData.append("action", "update");

      const resp = await post("/block_ipaddress.php", formData);

      if (resp) {
        const index = visitsData.findIndex((val) => val.id == id);
        const prevData = visitsData;
        prevData[index].reason = reasonMessage;
        prevData[index].status = 0;

        setVisitsData([...prevData]);
        setResonMessage("");
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="p-3">
      <TitleComp
        name="Visited Users"
        type="Visited"
        totalData={pagination.total}
        button={false}
        setSearchInput={setSearchInput}
      />
      <div className="d-none d-md-block">
        <Table
          columns={columns}
          dataSource={visitsData}
          pagination={false}
          loading={loading}
          className="component-table"
        />
        <Pagination
          current={pagination.current}
          pageSize={pagination.pageSize}
          total={pagination.total}
          onChange={(page, pageSize) =>
            fetchVisits(page, pageSize, searchInput)
          }
          className="component-pagination"
        />
      </div>
      <div className="d-block d-md-none">
        {visitsData?.map((val) => (
          <Card
            key={val.id}
            title={`IP: ${val.ip_address}`}
            className="component-card mb-3"
            extra={
              <div className="d-flex">
                {val.status == "1" ? (
                  <Popconfirm
                    placement="topLeft"
                    title="Are sure you want to block this IP ?"
                    description={
                      <TextArea
                        value={reasonMessage}
                        onChange={(e) => setResonMessage(e.target.value)}
                        maxLength={250}
                        placeholder="Reason"
                      />
                    }
                    okText="Yes"
                    onConfirm={() => handleOk(val.id, 0)}
                    cancelText="No"
                  >
                    <Button
                      icon={<ImBlocked />}
                      className="bg-danger text-white mx-3"
                      style={{ height: "35px" }}
                    >
                      Blocked This
                    </Button>
                  </Popconfirm>
                ) : (
                  <Button
                    icon={<FaUniversalAccess />}
                    className="bg-success text-white mx-3"
                    style={{ height: "35px" }}
                    onClick={() => handleOk(val.id, 1)}
                  >
                    Unblocked This
                  </Button>
                )}
              </div>
            }
          >
            {columns.map(
              (colmVal) =>
                colmVal.key !== "action" && (
                  <p>
                    <strong>{colmVal.title}:</strong>
                    {colmVal.key === "created_at"
                      ? moment(val[colmVal.key]).format("llll")
                      : val[colmVal.key]}
                  </p>
                )
            )}
          </Card>
        ))}
      </div>
    </div>
  );
}
